import {http} from '../config';
export default{


    listarProductosPublico:(identificador)=>{
        return http.get('api/productos/publico/'+identificador);
    },

    listarProductos:()=>{
        return http.get('api/productos');
    },
    save:(producto)=>{
        return http.post('api/productos',producto)
    },
   update: (producto) => {
  return http.put('api/productos/' + producto.id, producto)
},
    delete:(producto)=>{
        return http.delete('api/productos/'+producto.id)
    }
    ,
    storeImg:(producto)=>{
        return http.post('api/productos/store_img_unico_producto/'+producto.id,producto)
    }
    ,
    getImg:(producto)=>{
        return http.get('api/productos/get_img_unico_producto/'+producto.id,producto)
    }

   // .listarProductosPublico()
}
